export function intToChinese(num) {
  const arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  const arr2 = [
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
  ];
  if (!num || isNaN(num)) return "零";
  const numStr = num.toString().split("");
  let result = "";
  for (let i = 0; i < numStr.length; i++) {
    const des_i = numStr.length - 1 - i;
    result = arr2[i] + result;
    const arr1_index = numStr[des_i];
    result = arr1[arr1_index] + result;
  }
  result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十");
  result = result.replace(/零+/g, "零");
  result = result.replace(/零亿/g, "亿").replace(/零万/g, "万");
  result = result.replace(/亿万/g, "亿");
  result = result.replace(/零+$/, "");
  result = result.replace(/^一十/g, "十");
  return result;
}

export function formatClazzName(clazz) {
  return `${clazz.year}级${parseInt(clazz.name).toLocaleString(undefined, {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}班`;
}

export function formatScore(num) {
  if (!num) return "0.00";
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatSeqNo(num) {
  return num.toLocaleString(undefined, {
    maximumFractionDigits: 0,
    minimumIntegerDigits: 2,
  });
}

export function getImgUrl(iconname) {
  var images = require.context("@/static/images/index", false, /\.png$/);
  return images("./" + iconname + ".png");
}

/** 类似java String.format 格式化字符串 */
export function parse(str) {
  var args = [].slice.call(arguments, 1),
    i = 0;
  return str.replace(/%s/g, () => args[i++]);
}

export function scrollToBottom() {
  setTimeout(() => {
    document.getElementById("main").scrollTo({
      top: document.getElementById("main").scrollHeight,
      behavior: "smooth",
    });
  }, 1000);
}

// 递归方法
export function getTreeData(data) {
  if (!data) return;
  // 循环遍历json数据
  for (var i = 0; i < data.length; i++) {
    if (data[i].children?.length < 1) {
      // children若为空数组，则将children设为undefined
      data[i].children = undefined;
    } else {
      // children若不为空数组，则继续 递归调用 本方法
      this.getTreeData(data[i].children);
    }
  }
  return data;
}
